import { createSlice } from "@reduxjs/toolkit";
import { IAutoHostnote } from "src/components/teachBesty";
import { RootState } from "src/redux/store";

interface TeachBestyState {
  data: {
    autoHostnotes: IAutoHostnote[];
    totalCount: number;
  } | null;
  statusFilter: "all" | "pending" | "accepted";
  page: number;
  pageSize: number;
}

const initialState: TeachBestyState = {
  data: null,
  statusFilter: "pending",
  page: 1,
  pageSize: 10,
};

const teachBestySlice = createSlice({
  name: "teachBesty",
  initialState,
  reducers: {
    setTeachBestyData: (state, action) => {
      state.data = action.payload;
    },
    setStatusFilter: (state, action) => {
      state.statusFilter = action.payload;
      state.page = 1; // Reset to first page on filter change
    },
    setPage: (state, action) => {
      state.page = action.payload;
    },
    setPageSize: (state, action) => {
      state.pageSize = action.payload;
      state.page = 1; // Reset to first page on page size change
    },
    updateAutoHostnoteInList: (state, action) => {
      if (state.data?.autoHostnotes) {
        const index = state.data.autoHostnotes.findIndex((note: any) => note.id === action.payload.id);
        if (index !== -1) {
          state.data.autoHostnotes[index] = action.payload;
        }
      }
    },
    removeAutoHostnoteFromList: (state, action) => {
      if (state.data?.autoHostnotes) {
        state.data.autoHostnotes = state.data.autoHostnotes.filter((note) => note.id !== action.payload);
        state.data.totalCount -= 1;
      }
    },
  },
});

export const {
  setTeachBestyData,
  setStatusFilter,
  updateAutoHostnoteInList,
  removeAutoHostnoteFromList,
  setPage,
  setPageSize,
} = teachBestySlice.actions;

export const getTeachBestyState = (state: RootState) => state.teachBesty;

export default teachBestySlice.reducer;
